import axios from "axios";
import { getUserData } from "@/auth/utils";
import useJwt from "@/auth/jwt/useJwt";
import { initialAbility } from "@/libs/acl/config";
import ToastificationContent from "@core/components/toastification/ToastificationContent";

function convertNumbers2English(number) {
  if (number) {
    return number.replace(/[\u0660-\u0669\u06f0-\u06f9]/g, function (c) {
      return c.charCodeAt(0) & 0xf;
    });
  }
}

async function processPayloadsRecursively(payloads) {
  if (!payloads) {
    // Base case: Stop recursion if the payload is falsy
    return;
  }

  if (Array.isArray(payloads)) {
    // If it's an array, process each element recursively
    for (const payload of payloads) {
      await processPayload(payload);
    }
  } else {
    // If it's not an array, process it directly
    await processPayload(payloads);
  }
}

async function processPayload(payload) {
  try {
    // Determine the type of payload and process it accordingly
    if (payload instanceof FormData) {
      // If it's FormData, make a POST request with it
      return;
    } else if (Array.isArray(payload)) {
      // If it's an array, recursively process its elements
      await processPayloadsRecursively(payload);
    } else if (typeof payload === "object") {
      // If it's an object, you can process it as needed
      Object.keys(payload).forEach((item) => {
        if (typeof payload[item] === "object") {
          processPayloadsRecursively(item);
          return;
        } else if (typeof payload[item] === "string") {
          payload[item] = convertNumbers2English(payload[item]);
        } else {
          payload[item] = convertNumbers2English(payload[item].toString());
          return;
        }
      });
    } else {
      // Handle other types as needed
      console.warn("Unsupported payload type:", typeof payload);
    }
  } catch (error) {
    console.error(error);
  }
}
class WebServiceRequest {
  static baseUrl = `${process.env.VUE_APP_BASE_URL}/api/`;

  constructor(context) {
    this.context = context;
    this.data = {
      meta: {},
      request: {},
    };
    this.queryUrl = {};
    let userToken = null;
    if (getUserData() && getUserData().token) {
      userToken = getUserData().token;
      // const userLanguageId = getUserData().user.languageId;
      // this.userLanguageId = userLanguageId;
      this.userToken = userToken;
      axios.defaults.headers.common["Authorization"] = userToken;
    }
    axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
  }

  getData() {
    return this.data;
  }

  setTag(tag) {
    this.tag = tag;
  }

  getTag() {
    return this.tag;
  }

  setRequestParam(value) {
    // this.queryUrl[key] = value
    let tempVal = JSON.parse(JSON.stringify(value));
    if (tempVal) {
      Object.keys(tempVal).forEach((item) => {
        // Convert numbers to english
        if (item && tempVal[item]) {
          tempVal[item] = convertNumbers2English(tempVal[item].toString());
        }

        // Delete empty items
        if (
          !tempVal[item] &&
          tempVal[item] !== false &&
          tempVal[item] !== 0 &&
          tempVal[item] !== "0"
        ) {
          delete tempVal[item];
        }
      });
    }
    this.queryUrl = tempVal;
    // if (this.userLanguageId) {
    // if (!this.queryUrl.languageId) {
    //   this.queryUrl["languageId"] = this.userLanguageId;
    // }
    // }
  }

  convertDataToQueryString() {
    return Object.keys(this.queryUrl)
      .map((key) => key + "=" + this.queryUrl[key])
      .join("&");
  }

  setMetaParam(key, value) {
    this.data.meta[key] = value;
  }

  setRequestParamDataObj(value) {
    let deepCloned = JSON.parse(JSON.stringify(value));
    Object.keys(deepCloned).forEach((item) => {
      if (
        !deepCloned[item] &&
        deepCloned[item] !== false &&
        deepCloned[item] !== 0
      ) {
        delete deepCloned[item];
      }
    });
    processPayloadsRecursively(deepCloned);

    this.data = deepCloned;
  }

  setFormData(data) {
    this.formData = data;
  }
  getFormData() {
    return this.formData;
  }

  getUrl() {
    if (Object.keys(this.queryUrl).length > 0) {
      let query_string = this.convertDataToQueryString();
      return WebServiceRequest.baseUrl + this.tag + "?" + query_string;
    } else {
      return `${WebServiceRequest.baseUrl}${this.getTag()}`;
    }
  }

  async delete(successCallback, errorCallbac) {
    const _this = this;

    // try {
    const _data = await fetch(_this.getUrl(), {
      method: "DELETE", // *GET, POST, PUT, DELETE, etc.
      // mode: 'no-cors', // no-cors, *cors, same-origin
      // cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      // credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        "Content-Type": "application/json",
        // 'content-type': 'multipart/form-data;boundary=<calculated when request is sent>',
        "Access-Control-Allow-Origin": "*",
        // 'Access-Control-Allow-Origin': 'origin',
        Authorization: _this.userToken,
        platform: "Web",
      },
      // redirect: 'follow', // manual, *follow, error
      // referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      body: JSON.stringify(_this.getData()), // body data type must match "Content-Type" header
    }).then(async function (response) {
      if (response.status === 401) {
        localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName);
        localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName);

        // Remove userData from localStorage
        localStorage.removeItem("userData");

        // Reset ability
        _this.context.$ability.update(initialAbility);

        // Redirect to login page
        _this.context.$router.push({ name: "auth-login" });
      }
      if (response.status === 500) {
        _this.context.$toast({
          component: ToastificationContent,
          position: "bottom-center",
          props: {
            title: `توجه`,
            icon: "",
            variant: "danger",
            text: `مشکلی در سرور رخ داده است لطفا بعدا تلاش کنید.`,
          },
        });
        // _this.context.$router.back();
      }
      console.warn(response);
      if (response.status == 422) {
        _this.context.$toast({
          component: ToastificationContent,
          position: "bottom-center",
          props: {
            title: `توجه`,
            icon: "",
            variant: "danger",
            text: `شما دسترسی به این عملیات ندارید!.`,
          },
        });
      }
      if (response.status === 400) {
        // _this.context.$toast({
        //   component: ToastificationContent,
        //   position: "bottom-center",
        //   props: {
        //     title: `توجه`,
        //     icon: "",
        //     variant: "danger",
        //     text: `اطلاعات وارد شده صحیح نمیباشند.`,
        //   },
        // });
        throw new Error(isJson ? await response.json() : response);
      }
      const isJson = response.headers
        .get("content-type")
        ?.includes("application/json");
      const data = isJson ? await response.json() : response;
      return data;
    });

    if (_data) {
      successCallback(_data);
    } else {
      // errorCallback(_data);
    }
    // } catch (e) {
    //   return new Error(e);
    // }
  }

  async get(successCallback, errorCallback) {
    const _this = this;

    try {
      const _data = await fetch(_this.getUrl(), {
        method: "GET", // *GET, POST, PUT, DELETE, etc.
        // mode: 'no-cors', // no-cors, *cors, same-origin
        // cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        // credentials: 'same-origin', // include, *same-origin, omit
        headers: {
          "Content-Type": "application/json",
          // 'content-type': 'multipart/form-data;boundary=<calculated when request is sent>',
          "Access-Control-Allow-Origin": "*",
          // 'Access-Control-Allow-Origin': 'origin',
          Authorization: this.userToken,
        },
        // redirect: 'follow', // manual, *follow, error
        // referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        // body: JSON.stringify(this.getData()) // body data type must match "Content-Type" header
      }).then(function (response) {
        if (response.status === 201) {
          // return successCallback ()
        }
        if (response.status === 401) {
          // Remove userData from localStorage
          // localStorage.removeItem('userData')
          // Redirect to login page
          // this.context.$router.push({name: 'auth-login'})
        }
        if (response.status === 500) {
          this.context.$router.back();
        }
        if (response.status === 400) {
          // return _this.context.$toast.error("Data is not correct!");
        }
        return response.json();
      });
      if (_data) {
        successCallback(_data);
      } else {
        errorCallback(_data);
      }
    } catch (e) {
      // Helper.closeLoadingOverlay(this.context);
      console.log(e);
    }
  }

  async fetch(successCallback, errorCallbac) {
    const _this = this;

    // try {
    const _data = await fetch(_this.getUrl(), {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      // mode: 'no-cors', // no-cors, *cors, same-origin
      // cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      // credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        "Content-Type": "application/json",
        // 'content-type': 'multipart/form-data;boundary=<calculated when request is sent>',
        "Access-Control-Allow-Origin": "*",
        // 'Access-Control-Allow-Origin': 'origin',
        Authorization: _this.userToken,
        platform: "Web",
      },
      // redirect: 'follow', // manual, *follow, error
      // referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      body: JSON.stringify(_this.getData()), // body data type must match "Content-Type" header
    }).then(async function (response) {
      if (response.status === 422) {
        _this.context.$toast({
          component: ToastificationContent,
          position: "bottom-center",
          props: {
            title: `توجه`,
            icon: "",
            variant: "danger",
            text: `دسترسی شما به این صفحه محدود می باشد.`,
          },
        });
        return;
        // return  { json: function() { return { isSuccess: false, message: 'دسترسی شما به این صفحه محدود می باشد.', errors: 'دسترسی شما به این صفحه محدود می باشد.' }; } };
      }
      if (response.status === 401) {
        localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName);
        localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName);

        // Remove userData from localStorage
        localStorage.removeItem("userData");

        // Reset ability
        _this.context.$ability.update(initialAbility);

        // Redirect to login page
        _this.context.$router.push({ name: "auth-login" });
      }
      if (response.status === 500) {
        _this.context.$toast({
          component: ToastificationContent,
          position: "bottom-center",
          props: {
            title: `توجه`,
            icon: "",
            variant: "danger",
            text: `مشکلی در سرور رخ داده است لطفا بعدا تلاش کنید.`,
          },
        });
        // _this.context.$router.back();
      }
      // if (response.status === 400) {
      //   // _this.context.$toast({
      //   //   component: ToastificationContent,
      //   //   position: "bottom-center",
      //   //   props: {
      //   //     title: `توجه`,
      //   //     icon: "",
      //   //     variant: "danger",
      //   //     text: `اطلاعات وارد شده صحیح نمیباشند.`,
      //   //   },
      //   // });
      //   throw new Error(isJson ? await response.json() : response);
      // }
      const isJson = response.headers
        .get("content-type")
        ?.includes("application/json");
      const data = isJson ? await response.json() : response;
      return data;
    });

    if (_data) {
      successCallback(_data);
    } else {
      // errorCallback(_data);
    }
    // } catch (e) {
    //   return new Error(e);
    // }
  }
  async sendFormData(successCallback, errorCallback) {
    const _this = this;

    await axios
      .post(this.getUrl(), this.getFormData(), {
        onUploadProgress: (progressEvent) => {
          this.context.uploaded = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
        },
        headers: {
          "Content-Type": "multipart/form-data",
          // 'content-type': 'multipart/form-data;boundary=<calculated when request is sent>',
          // 'Access-Control-Allow-Origin': '*',
          // 'Access-Control-Allow-Origin': 'origin',
          Authorization: _this.userToken,
          platform: "Web",
        },
      })
      .then(function (response) {
        const _data = response;
        if (_data) {
          successCallback(_data);
        } else {
          // token invalid mode
          // errorCallback(_data);
        }
      });
  }
}

export default WebServiceRequest;
